export default __webpack_public_path__ + "static/media/completed.6b630d61.svg";